import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import commonStyles from 'pages/home/styles';
import { withStyles } from 'theme/withStyles';
import { useDispatch, useSelector } from 'react-redux';
import dialogActions from 'core/dialogs/actions';
import Button from 'common/Button';
import { WORKFLOW_ROOT } from 'config/api';

const styles = (theme) => {
  const common = commonStyles(theme);
  return {
    ...common,
    cardBody: {
      '& ul li': {
        ...theme.typography.p3,
        '& span.label': {
          fontWeight: theme.typography.fontWeights.medium,
          marginRight: 10,
          maxWidth: '30%',
          minWidth: '30%',
          textAlign: 'right',
        },
        '& span.value': {
          marginLeft: 10,
        },
        lineHeight: '20px',
        paddingBottom: 0,
      },
      width: '100%',
    },
    cardHeader: {
      '& .compayLogo': {
        '& img': {
          height: '100%',
        },
        height: 30,
      },

      display: 'flex',
      paddingBottom: 10,
    },
    cardsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        marginBottom: 0,
      },
      width: '100%',
    },
    companyName: {
      lineHeight: 2,
      padding: '0 10px',
    },
    individualCard: {
      border: `1px solid ${theme.palette.grey.light}`,
      borderRadius: theme.spacing.unit * 2,
      marginBottom: 20,
      padding: 20,
      width: '100%',

      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        width: '100%',
      },
    },
  };
};

const AccountCard = ({ classes, fieldName }) => {
  const { data, fields } = useSelector((state) => state);
  const dispatch = useDispatch();

  const accounts = data[fieldName] || undefined;
  const { lookupOrder } = fields[fieldName];

  if (!lookupOrder) return null;

  return (
    <div className={classnames('', classes.cardsContainer)}>
      {accounts?.map((accountDetail) => {
        const { companyLogoUrl, companyName, ...udpatedCompanyDetails } = accountDetail;
        return (
          <div key={accountDetail.routingNumber} className={classnames('', classes.individualCard)}>
            <div className={classnames('', classes.cardHeader)}>
              {companyLogoUrl && (
                <div className="compayLogo">
                  <img src={companyLogoUrl} alt={`${companyName} Logo`} />
                </div>
              )}
              <div className={classnames('', classes.companyName)}>{companyName}</div>
            </div>
            <div className={classnames('', classes.cardBody)}>
              <ul>
                {lookupOrder
                  .filter((item) => !!udpatedCompanyDetails[item])
                  .map((lookupItem) => (
                    <li key={lookupItem} className={classnames('', classes.listItem)}>
                      <span className="label">{fields[fieldName].lookupValues[lookupItem]}</span> :
                      <span className="value">{accountDetail[lookupItem]}</span>
                      {lookupItem === 'pdfStored' && accountDetail[lookupItem] === true && (
                        <Button
                          variant="link"
                          onClick={(e) => {
                            e.preventDefault();
                            const pdfUrl = `${WORKFLOW_ROOT}/home/${
                              accountDetail.taskId
                            }/manualfallback?eventTime=${encodeURIComponent(
                              accountDetail.eventTime,
                            )}`;
                            dispatch(
                              dialogActions.open('genericPDF', {
                                pdfUrl,
                              }),
                            );
                          }}
                        >
                          View Form
                        </Button>
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};
AccountCard.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fieldName: PropTypes.string.isRequired,
};

AccountCard.defaultProps = {};

export default withStyles(styles)(AccountCard);
